import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Draggable wrapper for a whole Kanban list (column).
// data.type lets the board's onDragEnd tell columns apart from cards.
//
// Only the list's name/header should start a column drag — the rest of
// the column (cards, "Add Card" link, etc.) must stay interactive for
// its own clicks/drags. So the drag listeners are NOT spread on the
// outer wrapper; instead `children` is called as a render-prop with
// `dragHandleProps` that the caller spreads onto just the header.
const SortableList = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: { type: "column" },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 40 : undefined,
  };

  // Keep the board's mouse-pan handler from hijacking a column drag:
  // stop the events from bubbling to the scroll container.
  const dragHandleProps = {
    ...attributes,
    ...listeners,
    onPointerDown: (e) => {
      e.stopPropagation();
      listeners?.onPointerDown?.(e);
    },
    onMouseDown: (e) => e.stopPropagation(),
  };

  return (
    <div ref={setNodeRef} style={style}>
      {typeof children === "function"
        ? children({ dragHandleProps })
        : children}
    </div>
  );
};

export default SortableList;
